import { useId, type ReactNode } from 'react'
import { Button, Empty, Flex, Typography, theme } from 'antd'

/**
 * Bo'sh holatning TURI — har biriga alohida illyustratsiya.
 *
 * ⚠️ BITTA UNIVERSAL RASM ATAYLAB RAD ETILDI. "Ma'lumot yo'q", "qurilma
 * sozlanmagan" va "huquqingiz yo'q" — uchta BOSHQA vaziyat va uchtasida
 * operator boshqa narsa qilishi kerak. Bitta rasm ularni bir xil ko'rsatib,
 * rasmni bezakka aylantirardi: ko'z uni bir haftada umuman ko'rmay qo'yadi.
 */
export type EmptyVariant = 'no-data' | 'no-device' | 'no-permission' | 'error'

interface EmptyStateProps {
  /** Bo'sh holat turi — illyustratsiyani tanlaydi (standart: `no-data`) */
  variant?: EmptyVariant
  /**
   * Ikonkani QO'LDA berish — variant illyustratsiyasi o'rniga.
   *
   * ⚠️ Yangi kodda KERAK EMAS: `variant` bo'yicha rasm butun panelda bir xil
   * bo'lishi uchun. Maydon mavjud chaqiruvchilar (`VouchersPage`,
   * `UserPermissionsPanel`) uchun saqlangan — ular boshqa agentlar
   * egaligida va bir vaqtda o'zgartirilmaydi.
   */
  icon?: ReactNode
  title: string
  /** Nima uchun bo'sh va nima qilish kerakligini tushuntiradi */
  description?: string
  /** Harakat tugmasi — bo'sh holat boshi berk ko'cha bo'lmasin */
  actionLabel?: string
  onAction?: () => void
}

interface ArtProps {
  id: string
  token: ReturnType<typeof theme.useToken>['token']
}

/**
 * ⚠️ ILLYUSTRATSIYALAR INLINE SVG — RASTR (PNG/3D) EMAS.
 *
 * Uchta sabab, uchalasi ham amaliy:
 *
 * 1. **Mavzu.** Panel standart holatda QORONG'I (07-FRONTEND.md §4) va
 *    operator uni almashtira oladi. PNG ning rangi qotib qolgan: yorug'
 *    mavzu uchun chizilgan rasm qorong'ida oq dog' bo'lib turadi. Bu yerda
 *    har bir rang `theme.useToken()` dan keladi, ya'ni rasm mavzu bilan
 *    BIRGA o'zgaradi.
 * 2. **Yuklama va CSP.** Rasm build ichida, alohida so'rov yo'q, tashqi
 *    manba yo'q. Uchta panel bor va rasm paketi uchalasiga tarqalardi.
 * 3. **O'lcham.** `viewBox` bilan cho'ziladi — bir xil rasm 44 px da ham,
 *    160 px da ham aniq qoladi.
 *
 * "3D his" `linearGradient` va yumshoq soya bilan beriladi: hajm ko'rinadi,
 * lekin fayl baribir bir necha yuz bayt.
 *
 * ⚠️ `id` — `useId()` dan. Gradient identifikatorlari HUJJAT BO'YICHA
 * global: bitta sahifada ikkita bo'sh holat bo'lsa (masalan ikki jadval),
 * qotirilgan `id` ikkinchisini birinchisining gradientiga bog'lab qo'yardi
 * va rasm tasodifan boshqa rangda chiqardi.
 */
function NoDataArt({ id, token }: ArtProps) {
  return (
    <svg viewBox="0 0 120 96" width="100%" height="100%" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id={`${id}-box`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={token.colorFillSecondary} />
          <stop offset="100%" stopColor={token.colorFillQuaternary} />
        </linearGradient>
      </defs>
      {/* Yumshoq soya — chuqurlik illyuziyasi */}
      <ellipse cx="60" cy="82" rx="34" ry="6" fill={token.colorFillQuaternary} />
      {/* Ortdagi varaqlar — "bu yerda ma'lumot bo'lishi kerak edi" */}
      <rect x="34" y="14" width="52" height="34" rx="4" fill={token.colorFillQuaternary} />
      <rect x="30" y="22" width="60" height="38" rx="5" fill={token.colorFillTertiary} />
      {/* Old lotok */}
      <path
        d="M22 46h22l6 9h20l6-9h22v24a6 6 0 0 1-6 6H28a6 6 0 0 1-6-6z"
        fill={`url(#${id}-box)`}
        stroke={token.colorBorderSecondary}
        strokeWidth="1.5"
      />
      <path d="M42 32h36M42 40h24" stroke={token.colorTextQuaternary} strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}

function NoDeviceArt({ id, token }: ArtProps) {
  return (
    <svg viewBox="0 0 120 96" width="100%" height="100%" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id={`${id}-dev`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={token.colorFillSecondary} />
          <stop offset="100%" stopColor={token.colorFillQuaternary} />
        </linearGradient>
      </defs>
      <ellipse cx="60" cy="80" rx="32" ry="6" fill={token.colorFillQuaternary} />
      {/* Antennalar — signal YO'Q, shuning uchun to'lqin chizilmaydi */}
      <path
        d="M40 46V28M80 46V28"
        stroke={token.colorTextQuaternary}
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      {/* Router korpusi */}
      <rect
        x="26"
        y="46"
        width="68"
        height="26"
        rx="6"
        fill={`url(#${id}-dev)`}
        stroke={token.colorBorderSecondary}
        strokeWidth="1.5"
      />
      {/* Indikatorlar — HAMMASI SO'NGAN: qurilma yo'q, xato emas */}
      <circle cx="40" cy="59" r="3" fill={token.colorTextQuaternary} />
      <circle cx="52" cy="59" r="3" fill={token.colorTextQuaternary} />
      <circle cx="64" cy="59" r="3" fill={token.colorTextQuaternary} />
      {/* Bo'sh joyni ko'rsatuvchi uzuq kontur — "shu yerga qo'shiladi" */}
      <rect
        x="26"
        y="46"
        width="68"
        height="26"
        rx="6"
        fill="none"
        stroke={token.colorPrimary}
        strokeOpacity="0.35"
        strokeWidth="1.5"
        strokeDasharray="5 5"
      />
    </svg>
  )
}

function NoPermissionArt({ id, token }: ArtProps) {
  return (
    <svg viewBox="0 0 120 96" width="100%" height="100%" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id={`${id}-shield`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor={token.colorFillSecondary} />
          <stop offset="100%" stopColor={token.colorFillQuaternary} />
        </linearGradient>
      </defs>
      <ellipse cx="60" cy="82" rx="26" ry="5" fill={token.colorFillQuaternary} />
      {/* Qalqon — "taqiqlangan" emas, "himoyalangan": bu xato emas */}
      <path
        d="M60 14l24 9v22c0 17-10 26-24 31-14-5-24-14-24-31V23z"
        fill={`url(#${id}-shield)`}
        stroke={token.colorBorderSecondary}
        strokeWidth="1.5"
      />
      {/* Qulf */}
      <path
        d="M53 46v-5a7 7 0 0 1 14 0v5"
        fill="none"
        stroke={token.colorTextQuaternary}
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <rect x="49" y="46" width="22" height="17" rx="3" fill={token.colorTextQuaternary} />
    </svg>
  )
}

function ErrorArt({ id, token }: ArtProps) {
  return (
    <svg viewBox="0 0 120 96" width="100%" height="100%" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id={`${id}-err`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={token.colorErrorBg} />
          <stop offset="100%" stopColor={token.colorErrorBgHover} />
        </linearGradient>
      </defs>
      <ellipse cx="60" cy="82" rx="28" ry="5" fill={token.colorFillQuaternary} />
      {/*
        ⚠️ QIZIL FAQAT SHU VARIANTDA. Qolgan uchtasi neytral kulrangda:
        ma'lumot yo'qligi nosozlik EMAS (X-SIB-020). Rang o'z ma'nosini
        faqat kam ishlatilganda saqlaydi.
      */}
      <path
        d="M60 20l32 52H28z"
        fill={`url(#${id}-err)`}
        stroke={token.colorError}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path d="M60 38v16" stroke={token.colorError} strokeWidth="3.5" strokeLinecap="round" />
      <circle cx="60" cy="62" r="2.5" fill={token.colorError} />
    </svg>
  )
}

const ART: Record<EmptyVariant, (props: ArtProps) => ReactNode> = {
  'no-data': NoDataArt,
  'no-device': NoDeviceArt,
  'no-permission': NoPermissionArt,
  error: ErrorArt,
}

/**
 * Bo'sh holat: illyustratsiya + sarlavha + tushuntirish + harakat tugmasi.
 *
 * NEGA shunday: yalang'och "ma'lumot yo'q" yozuvi foydalanuvchini nima
 * qilishni bilmay qoldiradi. Bu yerda doim IKKI narsa aytiladi — nega bo'sh
 * va (bo'lsa) nima bosish kerak.
 *
 * ⚠️ ILLYUSTRATSIYA SHU YERDA, har sahifada takrorlanmaydi. Sabab
 * texnikdan ko'ra tashkiliy: takrorlangan rasm bir necha oydan keyin
 * o'nta biroz boshqacha rasmga aylanadi va panel yamoqqa o'xshab qoladi.
 * Bir joydan o'zgartiriladi — hamma joyda o'zgaradi.
 */
export function EmptyState({
  variant = 'no-data',
  icon,
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  const { token } = theme.useToken()
  // `useId` ichida `:` bo'ladi (`:r3:`) — u CSS selektorida yaroqsiz, lekin
  // bizga faqat `url(#...)` kerak, u esa aynan matnni oladi. Baribir
  // tozalaymiz: SVG `id` si sifatida bu qiymat hujjatga yoziladi.
  const rawId = useId()
  const gradientId = `xsib-empty-${rawId.replace(/[^a-zA-Z0-9_-]/g, '')}`
  const Art = ART[variant]

  return (
    <Empty
      image={
        icon ? (
          <div style={{ fontSize: 44, color: token.colorTextQuaternary, lineHeight: 1 }}>{icon}</div>
        ) : (
          // Balandlik cheklangan, kengligi esa erkin: bo'sh holat jadval
          // ichida ham, butun sahifada ham bir xil ko'rinishi kerak
          <div style={{ width: 132, maxWidth: '100%', margin: '0 auto' }}>
            <Art id={gradientId} token={token} />
          </div>
        )
      }
      styles={{ image: { height: 'auto', marginBottom: 12 } }}
      description={
        <Flex vertical align="center" gap={6} style={{ maxWidth: 420, margin: '0 auto' }}>
          <Typography.Text strong style={{ fontSize: 15 }}>
            {title}
          </Typography.Text>
          {description ? (
            <Typography.Text type="secondary" style={{ fontSize: 13 }}>
              {description}
            </Typography.Text>
          ) : null}
        </Flex>
      }
    >
      {actionLabel && onAction ? (
        <Button type="primary" onClick={onAction}>
          {actionLabel}
        </Button>
      ) : null}
    </Empty>
  )
}
